interface Props {
  serviceType: string;
  date: string | Date;
  startOrEndDate: string;
}

const STORED_DATE_STRING = /^\d{4}-\d{2}-\d{2}$/;

function pad2(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}

function formatLocalYmd(year: number, monthIndex: number, day: number): string {
  return `${year}-${pad2(monthIndex + 1)}-${pad2(day)}`;
}

/**
 * Letzter Kalendertag eines Monats — zeitzonenunabhängig (reine Arithmetik).
 * monthIndex: 0-basiert (0 = Januar).
 */
function lastDayOfMonth(year: number, monthIndex: number): number {
  const month = monthIndex + 1; // 1-12
  if (month === 2) {
    const leap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    return leap ? 29 : 28;
  }
  if (month === 4 || month === 6 || month === 9 || month === 11) {
    return 30;
  }
  return 31;
}

function toSourceDate(date: Props['date']): Date {
  if (date instanceof Date) {
    return date;
  }
  if (date) {
    return new Date(date);
  }
  return new Date();
}

function startOrEndDateForService({ serviceType, date, startOrEndDate }: Props) {
  // Bereits serialisierte Kalenderdaten unverändert durchreichen (kein Date-Re-Parse).
  if (typeof date === 'string' && STORED_DATE_STRING.test(date)) {
    return date;
  }

  // Date-Objekt-Eingaben: lokale Feld-Reads des bereits existierenden Objekts.
  // Sonst (String/fremd): einmalig parsen; Monatsende danach ohne lokales new Date.
  const source: Date = toSourceDate(date);
  const year = source.getFullYear();
  const monthIndex = source.getMonth();

  if (serviceType === 'MonthlyService' || serviceType === 'YearlyService') {
    if (startOrEndDate === 'endDate') {
      // Letzter Kalendertag zeitzonenunabhängig (kein lokales new Date für Monatsende).
      const lastDay = lastDayOfMonth(year, monthIndex);
      return formatLocalYmd(year, monthIndex, lastDay);
    }
    // Erster Kalendertag des Monats
    return formatLocalYmd(year, monthIndex, 1);
  }

  return formatLocalYmd(year, monthIndex, source.getDate());
}

export default startOrEndDateForService;
